import constant from './constant';

const initialState  = {
    loading: false,
    response: null,
    error: null,
};
export const updateDemographicReducer = (state = initialState , action)=> {
    switch(action.type){
        case constant.UPDATE_DEMOGRAPHICS_BEGIN: return {...state , loading : true};
        case constant.UPDATE_DEMOGRAPHICS_SUCCESS: return {...state , loading : false , response: constant.UPDATE_DEMOGRAPHICS_SUCCESS};
        case constant.UPDATE_DEMOGRAPHICS_ERROR: return {...state , loading: false , error: action.payload};
        case constant.UPDATE_DEMOGRAPHICS_CLEANUP: return initialState;
        default: return state;
    }
};